import { LinkButton, Theme, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { CONTACT_LINK } from 'shared/constants/links';
import { SOCIALS } from './constants';
import { clsx } from 'clsx';
import { NBSP } from 'shared/constants/symbols';

export const Footer: React.FC = () => {
  const device = useDeviceType();

  if (device === 'phone') {
    return (
      <div className={clsx(styles['container'], styles['container-phone'])}>
        <div className={styles['title']}>
          Оставайтесь в курсе последних{NBSP}новостей{NBSP}рынка недвижимости!
        </div>
        <div className={styles['socials']}>
          {SOCIALS.map(({ url, image }, key) => (
            <a className={styles['social']} key={key} href={url} target="_blank" rel="noreferrer">
              <div className={clsx(styles['image'], styles[image])} />
            </a>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={styles['container']}>
      <div className={styles['contact-container']}>
        <div className={styles['contact-textblock']}>
          <div className={styles['contact-title']}>Остались вопросы?</div>
          <div className={styles['contact-description']}>Напишите нам!</div>
        </div>
        <div className={styles['btn']}>
          <Theme theme="colored">
            <LinkButton theme="stroke_primary" href={CONTACT_LINK} target="_blank">
              Написать
            </LinkButton>
          </Theme>
        </div>
        <div></div>
      </div>
    </div>
  );
};
